import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'reports',
    lazy: async () => ({ Component: (await import('./ReportsPage')).ReportsPage }),
  },
];
